import React from "react";
import PropTypes from "prop-types";
import { Progress } from "reactstrap";
import arrowRight from "../assets/images/arrow-right.svg";
import arrowLeft from "../assets/images/arrow-left.svg";
import WOTCLogo from "../assets/images/wotcLogo.png";

const WizardFooter = props => {
  const {
    text,
    previousPage,
    nextPage,
    progress,
    previousLabel,
    nextLabel,
    max,
    what,
    intro,
    logo,
  } = props;

  return (
    <div className="row wizard-nav footer">
      <div className={`col ${intro ? "intro-background" : ""}`}>
        {previousPage && (
          <div className="left-container">
            <img src={arrowLeft} className="left-arrow" />
            <button type="button" onClick={previousPage} className="previous">
              <span className="d-md-none">{previousLabel || text.back}</span>
              <span className="d-none d-md-inline">
                {previousLabel || text.previous}
              </span>
            </button>
          </div>
        )}
        {intro && (
          <div className="left-container">
            {logo && <img className="intro-logo" src={logo} />}
            <img className="intro-logo" src={WOTCLogo} />
          </div>
        )}
      </div>
      <div
        className={`col-5 col-md-7 col-lg-8 progress-container ${
          intro ? "intro-background" : ""
        }`}
      >
        {!intro && (
          <div className="progress-content text-center text-lg-left">
            <span className="d-md-none">{`${progress} / ${max}`}</span>
            <span className="d-none d-md-inline">
              {`${progress} ${text.of} ${max} ${what}`}
            </span>
            <Progress max={max} value={progress} />
          </div>
        )}
      </div>
      <div className={`col ${intro ? "intro-background intro-continue" : ""}`}>
        {(nextPage && (
          <button type="button" onClick={nextPage} className="next">
            {nextLabel || text.next}
          </button>
        )) || (
          <div className="right-container">
            <button type="submit" className="next">
              {nextLabel || text.next}
            </button>
            <img src={arrowRight} className="right-arrow" />
          </div>
        )}
      </div>
    </div>
  );
};

WizardFooter.propTypes = {
  intro: PropTypes.bool,
  max: PropTypes.number,
  nextLabel: PropTypes.string,
  nextPage: PropTypes.func,
  previousLabel: PropTypes.string,
  previousPage: PropTypes.func,
  progress: PropTypes.number,
  text: PropTypes.object.isRequired,
  what: PropTypes.string,
  logo: PropTypes.string,
};

WizardFooter.defaultProps = {
  intro: false,
  max: 10,
  progress: 0,
  what: "answered",
  logo: "",
};

export default WizardFooter;



// WEBPACK FOOTER //
// ./src/components/WizardFooter.js